import { useEffect, useRef } from 'react';

/**
 * Run `task` on an interval while the component is mounted and the tab is
 * visible. The task rides in a ref, so the callback can close over fresh
 * state every render without re-arming the timer. Coming back to the tab
 * polls once immediately instead of waiting out the interval, and a hidden
 * tab costs nothing. A read that misses keeps whatever is on screen — the
 * next tick tries again.
 */
export function usePoll(task: () => void, ms: number): void {
  const latest = useRef(task);
  useEffect(() => {
    latest.current = task;
  });

  useEffect(() => {
    const run = () => {
      if (document.visibilityState === 'visible') latest.current();
    };
    const timer = window.setInterval(run, ms);
    document.addEventListener('visibilitychange', run);
    return () => {
      window.clearInterval(timer);
      document.removeEventListener('visibilitychange', run);
    };
  }, [ms]);
}
